import { IModuleConfiguration, ModuleConfiguration } from 'src/types/system_types';
import { HTTPInterceptor } from 'src/support/network/http_interceptor';
import { IFetchResponse } from '../types/hip_types';

import ess from'../../../pip/library/pi-ess/pi-ess.js';
import tt from'../../../pip/library/pi-tt/pi-tt.js';

declare global {
  interface Window {
    ['HIP']: any;
  }
}

export type INetworkModuleConfiguration = IModuleConfiguration;

export class NetworkModule extends ModuleConfiguration {
  configuration: INetworkModuleConfiguration;

  /**
   *
   * @param configuration
   */
  initialize(configuration: INetworkModuleConfiguration) {
    return new Promise((resolve) => {
      this.configuration = this.__defaultConfiguration(configuration);

      this.__listenEvent_networkFailure();
      this.__trackEvent_networkFailure();

      resolve(this.configuration);
    });
  }

  private __defaultConfiguration(configuration: INetworkModuleConfiguration) {
    return tt.mergeWith('clobber', {}, configuration) as INetworkModuleConfiguration;
  }

  private __apiResponseFailure__afterInterceptor = {
    statusCode: [],
    fn: <T>(uri: string, response: IFetchResponse, payload: T, htmlEl: HTMLElement) => {
      const interceptErrors__ahpNetwork: boolean | undefined = tt.get('$ahp.network.intercept_errors', htmlEl);
      if (interceptErrors__ahpNetwork === false) {
        return payload;
      }

      ess.failure({
        ns: 'ahp',
        site: 'api',
        action: 'invoke',
        source: uri,
        data: {
          metadata: htmlEl['metadata'] || {},
          response
        }
      });

      return payload;
    }
  };

  private __trackEvent_networkFailure() {
    HTTPInterceptor.instance.errorHTTP.push(this.__apiResponseFailure__afterInterceptor);
  }

  private __listenEvent_networkFailure() {
    ess.on(
      {
        ns: 'ahp',
        site: 'api',
        action: 'invoke',
        status: 'failure'
      },
      (errorResponse) => {
        const responseMetadata: Record<string, any> = tt.get('data.metadata', errorResponse) || {};
        const responseHTTP: { status: number; statusText?: string } =
          tt.get('data.response', errorResponse) || ({} as { status: number; statusText?: string });

        const errorMessage = tt.get('message', responseMetadata) as string;
        const title = errorMessage || `${responseHTTP.status >= 0 ? this.__getErrorTitle(responseHTTP.status) : ''}`;

        const errorsRaw: Record<string, string[]> = tt.get('errors', responseMetadata) as Record<string, string[]>;
        const errors = tt.reduce(
          (list: string[], messages) => {
            // TODO mix in field information
            return [...list, ...messages];
          },
          [],
          errorsRaw || []
        );

        const statusText =
          responseHTTP.status === -1
            ? 'Connection failure.'
            : responseHTTP.statusText !== 'unknown'
            ? responseHTTP.statusText
            : 'No explanation provided';

        const header = `<p><strong>${statusText}</strong></p>`;

        const messages =
          responseHTTP.status === -1
            ? navigator.onLine
              ? `The service is unavailable.`
              : `Your network connection is down.`
            : tt.isEmpty(errors)
            ? ''
            : `<ol kind="data">
              ${tt.reduce((s, error) => s + `<li>${error || ''}</li>`, '', errors)}
            </ol>`;

        window.HIP.fn.notify({
          status: 'error',
          title,
          details: `${header}${messages}`
        });
      }
    );
  }

  private __getErrorTitle(statusCode: number) {
    const titles = {
      400: 'Bad Request',
      401: 'Unauthorized User',
      403: 'Forbidden User',
      404: 'Page Not Found',
      500: 'Internal Server Error'
    };
    return titles[statusCode] || 'Network Request Issue';
  }
}
